import React from "react";

import share_icon from "../../../../assets/images/share_icon.png";

import AppText from "../AppText";

// ----------------------------------------------------------------------------

export default function HeaderActions(props) {
  const { style } = props;

  return (
    <div className="row" style={styles.content}>
      <a
        style={styles.iconCard}
        href={`mailto:${""}?subject=Cinquanta3WebApp&body=Visita questo link : ${
          document.URL
        }`}
      >
        <img src={share_icon} style={styles.icon} alt="" />
        <AppText xsmall style={styles.buttonText} bold noSpaces>
          condividi
        </AppText>
        <AppText xsmall style={styles.buttonText}>
          share
        </AppText>
      </a>
    </div>
  );
}
const styles = {
  icon: {
    height: 30,
    width: 30,
    marginBottom: 4,
    objectFit: "contain",
    alignSelf: "center",
    display: "flex",
  },
  buttonText: {
    textAlign: "center",
    height: 12,
  },
  iconCard: {
    marginRight: 15,
    width: 120,
    display: "flex",
    flexDirection: "column",
    textDecoration: "none",
    color: "inherit",
  },
};

// ----------------------------------------------------------------------------
